import { render, staticRenderFns } from "./chinaMap.vue?vue&type=template&id=ff218078&scoped=true&"
import script from "./chinaMap.vue?vue&type=script&lang=js&"
export * from "./chinaMap.vue?vue&type=script&lang=js&"
import style0 from "./chinaMap.vue?vue&type=style&index=0&id=ff218078&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff218078",
  null
  
)

export default component.exports